// import { IAdminData } from "./../../interfaces/admin.interface";
// import { IHttp, IHttpResponse } from "./../../interfaces/http.interface";
import { AxiosResponse } from "axios";
import axiosInstance from "../../axios/axios";
import { HardwareItemDto } from "./dtos/HardwareItemDto";
import { PricedHardwareItemDto } from "./dtos/PricedHardwareItemDto";
import { PricedHardwareItemsRequestDto } from "./dtos/PricedHardwareItemsRequestDto";
import QueryResponse from "./shared models/QueryResponse";
import { requestHeader } from "./sharedUtils";
import { SubmitHardwareOrderDto } from "../../pages/Order/CreateHardwareOrderModal/CreateHardwareOrderModal";

export const getHardware = async (): Promise<
  [QueryResponse<string[]> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<QueryResponse<string[]>>(
      `/allHardware`,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getHardwareItems = async (): Promise<
  [QueryResponse<HardwareItemDto[]> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<QueryResponse<HardwareItemDto[]>>(
      `/items/list`,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getPricedHardwareItems = async (
  requestDto: PricedHardwareItemsRequestDto
): Promise<[QueryResponse<PricedHardwareItemDto[]> | null, unknown]> => {
  try {
    const response = await axiosInstance.post<
      QueryResponse<PricedHardwareItemDto[]>
    >(`/items/calculate`, requestDto, requestHeader);
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const submitHardwareOrder = async (
  requestDto: SubmitHardwareOrderDto
): Promise<[AxiosResponse<number> | null, unknown]> => {
  try {
    const response = await axiosInstance.post<number>(
      "/OrderForm/Hardware",
      requestDto,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};
